"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "DASHBOARD", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.DASHBOARD;
  }
});
Object.defineProperty(exports, "EXTRACT_TRANSFER_LOAD", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.EXTRACT_TRANSFER_LOAD;
  }
});
Object.defineProperty(exports, "METADATA_MANAGEMENT", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.METADATA_MANAGEMENT;
  }
});
Object.defineProperty(exports, "MULTIPLE_DATA_SOURCES", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.MULTIPLE_DATA_SOURCES;
  }
});
Object.defineProperty(exports, "WEB_SERVICES", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.WEB_SERVICES;
  }
});

var _CategoryFeature = require("../CategoryFeature");


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ecosystem-marketplace-core/static-1.1225/js/constants/groupTags/categoryFeatures/IPaaS.js
// module id = 572
// module chunks = 209 210 211 212 213